/**
 * What: Merchant-facing copy for the synced store-settings summary in the Store Data tab (#3095).
 * Transport / data-flow: Pure string dictionary segment merged by shopify-component-copy.ts for Shopify UI consumers.
 *
 */
export const shopifyComponentStoreIntelligenceStoreSettingsCopy = {
    storeIntelligenceStoreSettings: {
        heading: 'Store settings',
        subtitle: 'Synced from Shopify with your latest store build.',
        currencyLabel: 'Currency',
        shopNameLabel: 'Store name',
        timezoneLabel: 'Timezone',
        domainLabel: 'Storefront domain',
        notSyncedBody: 'Not synced yet. Your store settings appear here after your first store build finishes.',
    },
};
//# sourceMappingURL=store-intelligence-store-settings.js.map